import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Row, Card, Form, Col, Button } from "react-bootstrap";
import {
  FormState,
  FormValue,
  initialFormState,
  invalidateStates,
} from "./FormState";
import { ValidationErrorResponse } from "../../../services/ValidationError";
import SuccessButton from "../../organisms/SuccessButton";
import ServerValidationErrorAlert from "../../organisms/ServerValidationErrorAlert";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import ServerErrorAlert from "../../organisms/ServerErrorAlert";
import LoadingScreen from "../../organisms/LoadingScreen";
import ValidationError from "../../../services/ValidationError";
import { capitalize } from "../../../utils/textUtils";
import { useNavigate } from "react-router-dom";
import { crearNuevoServicioHotel } from "./actions";
import CurrencyFormat from "react-currency-format";
import { StyledFormControl } from "../../organisms/StyledFormControl";
import CardTitle from "../../organisms/CardTitle";
import Exito, { ExitoOption } from "../../organisms/Exito";

function FormSection() {
  const [validatedForm, setValidatedForm] = useState(false);
  const [formState, setFormState] = useState(initialFormState);
  const [isLoading, setIsLoading] = useState(false);
  const [wasFinished, setWasFinished] = useState(false);
  const [crearOtroServicio, setCrearOtroServicio] = useState(false);
  const [serverFailedValidations, setServerFailedValidations] = useState(
    {} as ValidationErrorResponse
  );
  const [serverErrorOcurred, setServerErrorOcurred] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [esIndividual, setEsIndividual] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    if (wasFinished) {
      if (crearOtroServicio) {
        window.location.reload();
      } else {
        setIsFinished(true);
      }
    }
  }, [wasFinished, crearOtroServicio, navigate]);

  const save = async () => {
    setServerFailedValidations({} as ValidationErrorResponse);
    setServerErrorOcurred(false);
    setIsLoading(true);
    try {
      await crearNuevoServicioHotel(formState);
      setIsLoading(false);
      setWasFinished(true);
    } catch (error: any) {
      if (error instanceof ValidationError) {
        invalidateStates(formState, error.getFailedValidations());
        setServerFailedValidations(error.getFailedValidations());
      } else {
        setServerErrorOcurred(true);
      }
    }

    setIsLoading(false);
  };

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    const form = event.currentTarget as HTMLFormElement;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      save();
    }

    setValidatedForm(true);
  };

  const onInputChanged = ({ target }: any) => {
    const newInputState = {
      ...formState[target.name as keyof FormState],
      value: target.value,
      isValid: target.checkValidity(),
    };
    setFormState({ ...formState, [target.name]: newInputState });
  };

  const onInputChangedCapital = ({ target }: any) => {
    const newInputState = {
      ...formState[target.name as keyof FormState],
      value: capitalize(target.value),
      isValid: target.checkValidity(),
    };
    setFormState({ ...formState, [target.name]: newInputState });
  };

  const handleBlur = ({ target }: any) => {
    const newInputState = {
      ...formState[target.name as keyof FormState],
      wasTouched: true,
    };
    setFormState({ ...formState, [target.name]: newInputState });
  };

  if (isFinished) {
    return <Exito title={"¡Creación exitosa!"} options={exitoOptions} />;
  }

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-10 col-lg-8 col-xxl-5">
        <LoadingScreen isLoading={isLoading} />
        <Card>
          <StyledCardHeader className="pt-4 pb-4">
            <CardTitle>Servicio de Hotel</CardTitle>
          </StyledCardHeader>
          <Card.Body>
            {serverFailedValidations &&
              Object.keys(serverFailedValidations).length > 0 && (
                <Row className="justify-content-center mb-3">
                  <ServerValidationErrorAlert
                    serverFailedValidations={serverFailedValidations}
                    wrapperClass="col col-9"
                  />
                </Row>
              )}

            {serverErrorOcurred && (
              <Row className="justify-content-center mb-3">
                <ServerErrorAlert class="col col-9" />
              </Row>
            )}

            {serverErrorOcurred && <ServerErrorModal />}

            <Row className="justify-content-center">
              <Form
                className="col col-9"
                noValidate
                validated={validatedForm}
                onSubmit={handleSubmit}
              >
                <Form.Group as={Col} controlId="formNombre" className="mb-2">
                  <Form.Label>Nombre</Form.Label>
                  <StyledFormControl
                    type="text"
                    name="nombre"
                    value={formState.nombre.value}
                    onChange={onInputChangedCapital}
                    required
                    onBlur={handleBlur}
                    isValid={isRequiredFormValueValid(formState.nombre)}
                    isInvalid={isRequiredFormValueInvalid(formState.nombre)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Campo debe ser diligenciado.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  controlId="formDescripcion"
                  className="mb-2"
                >
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="descripcion"
                    value={formState.descripcion.value}
                    onChange={onInputChanged}
                    onBlur={handleBlur}
                    rows={3}
                    isValid={isFormValueValid(formState.descripcion)}
                    isInvalid={isFormValueInvalid(formState.descripcion)}
                  />
                  <Form.Text muted>Opcional.</Form.Text>
                </Form.Group>

                <Form.Group
                  as={Col}
                  controlId="formPrecioNoche"
                  className="mb-3"
                >
                  <Form.Label>Precio por noche</Form.Label>
                  <CurrencyFormat
                    customInput={Form.Control}
                    name="precioNoche"
                    value={formState.precioNoche.value}
                    thousandSeparator={","}
                    onBlur={handleBlur}
                    isValid={isRequiredFormValueValid(formState.precioNoche)}
                    isInvalid={isRequiredFormValueInvalid(
                      formState.precioNoche
                    )}
                    required
                    onChange={onInputChanged}
                    prefix={"$"}
                    decimalSeparator={"."}
                  />
                  <Form.Control.Feedback type="invalid">
                    Campo debe ser un número.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  controlId="formHoraSalida"
                  className="mb-2"
                >
                  <Form.Label>Hora de salida</Form.Label>
                  <StyledFormControl
                    type="number"
                    name="horaSalida"
                    value={formState.horaSalida.value}
                    onChange={onInputChanged}
                    onBlur={handleBlur}
                    isValid={isFormValueValid(formState.horaSalida)}
                    isInvalid={isFormValueInvalid(formState.horaSalida)}
                    min="0"
                    max="23"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Campo debe ser un número entre 0 y 23.
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="mb-4 mt-3">
                  <label className="mb-1">Es tarifa individual</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={esIndividual}
                      onChange={() => {
                        setEsIndividual((prev) => !prev);
                        setFormState({
                          ...formState,
                          minimoNoches: initialFormState.minimoNoches,
                          maximoNoches: initialFormState.maximoNoches,
                        });
                      }}
                    />
                    <label>{esIndividual ? "Si" : "No"} </label>
                  </div>
                </div>

                {!esIndividual && (
                  <>
                    <Form.Group
                      as={Col}
                      controlId="formMinimoNoches"
                      className="mb-2"
                    >
                      <Form.Label>Número mínimo de noches</Form.Label>
                      <StyledFormControl
                        type="number"
                        name="minimoNoches"
                        value={formState.minimoNoches.value}
                        onChange={onInputChanged}
                        onBlur={handleBlur}
                        isValid={isFormValueValid(formState.minimoNoches)}
                        isInvalid={isFormValueInvalid(formState.minimoNoches)}
                        min="0"
                      />
                      <Form.Control.Feedback type="invalid">
                        Campo debe ser un número.
                      </Form.Control.Feedback>
                      <Form.Text muted>Opcional.</Form.Text>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      controlId="formMaximoNoches"
                      className="mb-5"
                    >
                      <Form.Label>Número máximo de noches</Form.Label>
                      <StyledFormControl
                        type="number"
                        name="maximoNoches"
                        value={formState.maximoNoches.value}
                        onChange={onInputChanged}
                        onBlur={handleBlur}
                        isValid={isFormValueValid(formState.maximoNoches)}
                        isInvalid={isFormValueInvalid(formState.maximoNoches)}
                        min="0"
                      />
                      <Form.Control.Feedback type="invalid">
                        Campo debe ser un número.
                      </Form.Control.Feedback>
                      <Form.Text muted>Opcional.</Form.Text>
                    </Form.Group>
                  </>
                )}

                <ButtonsCol className="d-flex justify-content-center">
                  <Button
                    type="submit"
                    variant="primary"
                    onClick={() => setCrearOtroServicio(true)}
                  >
                    Registrar Otro Servicio
                  </Button>
                  <SuccessButton type="submit" variant="success">
                    Finalizar
                  </SuccessButton>
                </ButtonsCol>
              </Form>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const ButtonsCol = styled(Col)`
  gap: 1%;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

const isFormValueValid = (formValue: FormValue): boolean =>
  formValue.isValid === true && formValue.wasTouched;
const isRequiredFormValueValid = (formValue: FormValue): boolean =>
  formValue.isValid === true;
const isRequiredFormValueInvalid = (formValue: FormValue): boolean =>
  formValue.isValid === false;
const isFormValueInvalid = (formValue: FormValue): boolean =>
  formValue.isValid === false && formValue.wasTouched;

const exitoOptions: ExitoOption[] = [
  {
    description: "Crear nuevo servicio",
    path: "/servicios/hotel/crear",
    variant: "primary",
  },
  {
    description: "Ver listado",
    path: "/servicios/hotel",
    variant: "secondary",
    isLast: true,
  },
];

export default FormSection;
